import { Link } from "react-router-dom";
import { ArrowRight, Phone } from "lucide-react";
import { trackEvent } from "../lib/analytics";

const VARIANTS = {
  primary:
    "bg-forest text-ivory hover:bg-forest-dark shadow-[0_1px_0_rgba(33,74,64,0.2)]",
  outline:
    "border border-forest/30 bg-transparent text-forest hover:border-forest hover:bg-forest/5",
  ivory:
    "bg-ivory text-forest hover:bg-warmwhite border border-ivory/20",
  "outline-ivory":
    "border border-ivory/40 bg-transparent text-ivory hover:bg-ivory/10 hover:border-ivory",
};

export default function CTAButton({
  to,
  href,
  children,
  variant = "primary",
  className = "",
  event,
  testId,
  withArrow = true,
  onClick,
  ariaLabel,
}) {
  const classes = `inline-flex min-h-[48px] items-center justify-center gap-2.5 rounded-full px-7 py-3 text-[0.95rem] font-medium transition-[background-color,border-color,transform,box-shadow] duration-300 ease-out hover:-translate-y-0.5 active:translate-y-0 ${VARIANTS[variant]} ${className}`;

  const handleClick = (e) => {
    if (event) trackEvent(event, { cta_text: children });
    if (onClick) onClick(e);
  };

  if (href) {
    return (
      <a href={href} className={classes} data-testid={testId} onClick={handleClick} aria-label={ariaLabel}>
        {href.startsWith("tel:") && <Phone className="h-4 w-4" aria-hidden="true" />}
        {children}
      </a>
    );
  }
  return (
    <Link to={to || "/contact"} className={classes} data-testid={testId} onClick={handleClick} aria-label={ariaLabel}>
      {children}
      {withArrow && <ArrowRight className="h-4 w-4" aria-hidden="true" />}
    </Link>
  );
}
